
import { featureConfigMapping } from './pmax-text-asset-collection-config';

export const getTextAssetCollectionConfigByFeature = ({
  featureName,
}) => featureConfigMapping[featureName];
